import { AfterViewInit, Component, inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { TranslateService } from '@ngx-translate/core';
import { GoogleServiceComponent } from './google-service/google-service.component';
import { ScriptLoaderService } from '../../script-loader.service';
import { isPlatformBrowser } from '@angular/common';
import { EnvConfig } from '../environments/environment';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GooglePayButtonModule],
  templateUrl: './app.component.html',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.less',
  standalone: true,
})
export class AppComponent implements AfterViewInit {
  title = 'PBL-V1';
  private platformId = inject(PLATFORM_ID);
  private readonly scriptLoader = inject(ScriptLoaderService);
  private readonly translate = inject(TranslateService);

  // Language setup is now in the constructor for early, non-blocking initialization
  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      // Initialize translations immediately
      this.translate.setDefaultLang('fr');
      this.translate.use('fr');
      console.log('Translations set to French in constructor.');
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      let url = window.location.href;
      if (url.includes('google_pay')) {
        this.scriptLoader.loadScript('https://pay.google.com/gp/p/js/pay.js');
      }
      if (url.includes('apple_pay')) {
        this.scriptLoader.loadScript(
          'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
        );
      }

      //to be fixed by noor
      this.scriptLoader.loadScriptWithIntegrity(EnvConfig.risksdkURL, EnvConfig.risksdkIntegrity);
    }
  }
}
